"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubTitleWrapper = exports.StepWrapper = exports.LabelWrapper = exports.FlexWrapper = exports.Circle = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Circle = exports.Circle = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e7lmlwf4"
} : {
  target: "e7lmlwf4",
  label: "Circle"
})(props => /*#__PURE__*/(0, _react.css)("position:relative;display:flex;margin:auto;justify-content:center;align-items:center;height:32px;width:32px;border-radius:50%;border:2px solid ", props.color, ";background-color:", props.selected ? props.color : props.bg, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Circle;")));
const SubTitleWrapper = exports.SubTitleWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e7lmlwf3"
} : {
  target: "e7lmlwf3",
  label: "SubTitleWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3lfkp",
  styles: "display:flex;text-align:center;justify-content:center;max-width:350px"
} : {
  name: "1d3lfkp",
  styles: "display:flex;text-align:center;justify-content:center;max-width:350px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const StepWrapper = exports.StepWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e7lmlwf2"
} : {
  target: "e7lmlwf2",
  label: "StepWrapper"
})(props => /*#__PURE__*/(0, _react.css)("position:relative;display:flex;flex-grow:1;flex-basis:0;justify-content:center;padding:0 1rem;&>button{align-items:start;}&:not(:first-of-type){::before{content:'';position:absolute;right:calc(50% + 24px);top:16px;width:calc(50% - 24px);height:3px;background-color:", props.color, ";}}&:not(:last-of-type){::after{content:'';position:absolute;left:calc(50% + 24px);top:16px;width:calc(50% - 24px);height:3px;background-color:", props.color, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:StepWrapper;")));
const FlexWrapper = exports.FlexWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e7lmlwf1"
} : {
  target: "e7lmlwf1",
  label: "FlexWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "9gxvy4",
  styles: "display:flex;flex-direction:column;align-items:center;gap:0.5rem"
} : {
  name: "9gxvy4",
  styles: "display:flex;flex-direction:column;align-items:center;gap:0.5rem",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const LabelWrapper = exports.LabelWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e7lmlwf0"
} : {
  target: "e7lmlwf0",
  label: "LabelWrapper"
})();